// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../_css-loader@0.28.11@css-loader/index.js??ref--7-1!../../../_px2rem-loader@0.1.9@px2rem-loader/index.js??ref--7-2!./index.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../_vue-style-loader@3.1.2@vue-style-loader/lib/addStylesClient.js")("56a9bb9e", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../_css-loader@0.28.11@css-loader/index.js??ref--7-1!../../../_px2rem-loader@0.1.9@px2rem-loader/index.js??ref--7-2!./index.css", function() {
     var newContent = require("!!../../../_css-loader@0.28.11@css-loader/index.js??ref--7-1!../../../_px2rem-loader@0.1.9@px2rem-loader/index.js??ref--7-2!./index.css");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.13.2@vant/lib/collapse-item/index.css
// module id = 417
// module chunks = 320 321